export default "__VITE_ASSET__C1y6IPZ9__"